export default __webpack_public_path__ + "static/media/TZA.ad05ba5b.svg";